import React from 'react';
import { useField } from 'react-final-form';
import { NumberSelect } from '../../../ui/NumberSelect';
import { FormErrorField } from '../../AddNewItemForm/components/FormErrorField';
import { toNumberValue } from '../../../ui/NumberSelect/utils';

interface FormNumberSelectProps {
  name: string;
  max: number;
  placeholder: string;
  title?: string;
  disabledZero?: boolean;
  cypress?: string;
}

export const FormNumberSelect: React.FC<FormNumberSelectProps> = ({
  name,
  max,
  placeholder,
  title,
  disabledZero,
  cypress
}) => {
  const { input, meta } = useField(name, {
    subscription: { value: true, error: true, submitFailed: true }
  });

  const value = toNumberValue(input.value);
  const isError = meta.submitFailed && !!meta.error;

  return (
    <>
      <NumberSelect
        value={value}
        onChange={input.onChange}
        max={max}
        placeholder={placeholder}
        title={title}
        disabledZero={disabledZero}
        error={isError}
        cypress={cypress || name}
      />
      <FormErrorField field={name} cypress={`${name}-error`} />
    </>
  );
};
